import { Component, OnInit } from '@angular/core';
import { MakingTecaPost } from '../../shared/interface';
import { ApiService } from '../../services/api.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-making-teca',
  templateUrl: './making-teca.component.html',
  styleUrl: './making-teca.component.css'
})
export class MakingTecaComponent implements OnInit {
  
  posts: MakingTecaPost[] = []

  constructor(private apiService: ApiService, private router: Router) { }

  ngOnInit(): void {    

    this.apiService.getMakingTecaPosts().subscribe({
      next: (data) => this.posts = [...data],
      error: (err) => this.router.navigate(['/']),
    })
    
  }
}
